import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessKey } from "@/lib/api/client";

/**
 * Root index — redirects based on auth state:
 * - Has access key → /apps
 * - No access key → /login
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const accessKey = getAccessKey();
    if (accessKey) {
      throw redirect({ to: "/apps" });
    } else {
      throw redirect({ to: "/login" });
    }
  },
});
